import { Modal, NumberInput } from "components/UI"
import { runInAction } from "mobx";
import { Observer } from "mobx-react";
import Link from "next/link";
import translationStore from "stores/translation-store";
import { currencyFormat } from "utils/format";
import style from "./style"

export default function CartProduct(props)
{
  const onChange = () =>
  {
    if(props.onChange)
      props.onChange();
  }

  return (
    <Observer>
    {
      () =>
      {
        /** @type import('models/shop/product-model').default */
        const { product } = props;

        const title = props.showLink ? (<AlbumLink album={product.album}>{product.album.title.length > 0 ? product.album.title : translationStore.translate("myalbums.nameless")}</AlbumLink>) : (product.album.title.length > 0 ? product.album.title : translationStore.translate("myalbums.nameless"));
        return (
          <div className="cart-product">
            <CartProductImage product={product} />

            <div className="product-col">
              <div className="product-info">
                <div className="info-title">{title}</div>
                <div className="info-options">
                  <div key="option-type" className="info-option">
                    {translationStore.translate(`shop.product.${product.product.type}`)} {product.product.size.toUpperCase()}
                  </div>
                  <div key="option-cover" className="info-option">
                    {translationStore.translate(`shop.product.book.${product.product.booktype}.title`)}
                  </div>
                  {
                    product.options.map(option =>
                    {
                      return (
                        <div key={`option-${option}`} className="info-option">{translationStore.translate(`shop.option.${option}.title`)}</div>
                      );
                    })
                  }
                </div>
              </div>
              <div className="product-amount">
                <div className="product-quantity">
                  {
                    props.editable ?
                    <NumberInput
                      min={0}
                      max={1000}
                      value={product.quantity}
                      onChange={(quantity, prevQuantity) =>
                      {
                        if(quantity === 0)
                        {
                          runInAction(() => {
                            product.quantity = quantity;
                          });
                          
                          Modal.Confirm({
                            title: translationStore.translate("shop.page.cart.remove-product.title"),
                            description: translationStore.translate("shop.page.cart.remove-product.description"),
                            okButtonText: translationStore.translate("base.remove"),
                            cancelButtonText: translationStore.translate("base.cancel")
                          })
                          .then(() =>
                          {
                            product.remove();
                            onChange();
                          })
                          .catch(() => {
                            runInAction(() => {
                              product.quantity = prevQuantity;
                            });
                          })
                        }
                        else
                        {
                          runInAction(() => {
                            product.quantity = quantity;
                            onChange();
                          });
                        }
                      }}
                    /> :
                    translationStore.translate("shop.page.cart.amount", {amount: product.quantity})
                  }
                </div>
                <div className="product-price">
                  {currencyFormat(translationStore.getLanguage(), product.cart.currency, product.price / 100)}
                </div>
              </div>
            </div>

            <style jsx>{style}</style>
          </div>
        );
      }
    }
    </Observer>
  );
}

CartProduct.defaultProps = {
  editable: false,
  showLink: false
}

function CartProductImage(props)
{
  /** @type {import('models/shop/product-model').default} */
  const { product } = props;
  const isLegacyAlbum = product.album.key.length===12;

  const getBestImage = () =>
  {
    const { thumbs } = product.album;
    const width = 100;
    const height = 100;

    if(thumbs && Object.keys(thumbs).length > 0)
    {
      try
      {
        const { sizes } = thumbs.hasOwnProperty(product.orientation) ? thumbs[product.orientation] : thumbs.landscape;
        const pixelRatio = 1.5;
        const targetWidth = width * pixelRatio;
        const targetHeight = height * pixelRatio;

        let curSize = {width: Infinity, height: Infinity, url: "'"};
        sizes.forEach(thumbSize =>
        {
          if(thumbSize.width >= targetWidth && thumbSize.height >= targetHeight && (thumbSize.width < curSize.width || thumbSize.height < curSize.height))
            curSize = thumbSize;
        });

        return curSize.url;
      }
      catch(e){
        return "";
      }
    }

    return "";
  }

  if(isLegacyAlbum) {
    // api heeft geen cover preview ondersteuning voor legacy albums, dus dan zelf maar iets knutselen
    return (<div className={`product-image legacy ${product.orientation}`}>
      <div className="image"><div style={{backgroundImage: `url(${getBestImage()})`}}></div></div>
      <style jsx>{style}</style>
    </div>);
  }

  return (
    <div className="product-image" style={{backgroundImage: `url(${getBestImage()})`}}>
      <style jsx>{style}</style>
    </div>
  );
}

function AlbumLink({album, children, ...rest})
{
  if(album.key.length === 12)
  {
    return (
      <a
        {...rest}
        href={process.env.SITE_URL + `/album/${album.key}`}
      >
        {children}
      </a>
    );
  }

  return (
    <Link href={`/album/[album]`} as={`/album/${album.key}`} legacyBehavior>
      <a
        {...rest}
      >
        {children}
      </a>
    </Link>
  );
}